(function () {
  "use strict";

  angular
    .module("alk.import")
    .controller("importDetailsModalController", importDetailsModalController);

  importDetailsModalController.$inject = ["$scope", "$filter", "$uibModalInstance", "$translate", "alkModalService", "$timeout", "alkImportService", "_"];

  function importDetailsModalController($scope, $filter, $uibModalInstance, $translate, alkModalService, $timeout, alkImportService, _) {
    var vm = this;

    var entityNameText;
    var currentWizardData = alkModalService.getCurrentWizardData();
    var importFeatureType = currentWizardData.importFeatureType;

    vm.back = back;
    vm.cancel = cancel;
    vm.canSubmit = canSubmit;
    vm.errors = [];
    vm.categoryIcons = currentWizardData.categoryIcons;
    vm.changeSetCategory = changeSetCategory;
    vm.disableFinish = disableFinish;
    vm.file = currentWizardData.file;
    vm.getSetLabel = getSetLabel;
    vm.getDisplayErrors = getDisplayErrors;
    vm.headers = currentWizardData.headers;
    vm.isExceptionsImport = (importFeatureType === "ContentToolsExceptions");
    vm.importModalTitle = $translate.instant("common.import.setDetails");
    vm.importType = currentWizardData.importType || 0;
    vm.invalidCharRegex = alkImportService.invalidCharRegex;
    vm.isPlacesImport = (importFeatureType === "ContentToolsPlaces");
    vm.isStopsImport = (importFeatureType === "PCMWebUIStops");
    vm.importFunction = currentWizardData.importFunction;
    vm.inputRowsToCreate = currentWizardData.inputRowsToCreate;
    vm.selectedCategory = currentWizardData.categoryDefaultIcon; //if none exists
    vm.setName = "";
    vm.submitted = false;
    vm.setExistsMessage = $translate.instant("common.import.setNameExists");
    vm.setNameExists = setNameExists;
    vm.showSetName = showSetName;
    vm.sets = currentWizardData.sets;
    vm.showSetList = showSetList;
    vm.submit = submit;
    vm.updateSetNameFromFileName = updateSetNameFromFileName;
    vm.validate = validate;

    if (vm.isExceptionsImport) {
      vm.importModalTitle = $translate.instant("templates.importModifiers.importModifiers");
      vm.validate = validateExceptions;
      vm.submit = submitExceptions;
    }

    if (!currentWizardData.importType) { currentWizardData.importType = 0; }

    if (vm.isPlacesImport) {
      entityNameText = $translate.instant("templates.locations.places");
      if (!currentWizardData.copilotOptions) {
        currentWizardData.copilotOptions = {
          DisplayOnMap: true,
          Searchable: true,
          Alertable: true
        };
      }
      vm.copilotOptions = currentWizardData.copilotOptions;
    }
    else if (vm.isStopsImport) entityNameText = $translate.instant("templates.importStops.stops");
    else if (vm.isStopsImport) entityNameText = $translate.instant("templates.importModifiers.importModifiers");

    init();


    function init() {
      if (!vm.selectedSet && vm.sets.length > 0) {
        vm.selectedSet = vm.sets[0];
      }
      updateSetNameFromFileName();
    }

    function back() {
      const { geocodeResults } = currentWizardData;
      const wasGeocoded = Array.isArray(geocodeResults) && geocodeResults.length;
      $uibModalInstance.close({
        back: true,
        wasGeocoded
      });
    }

    function cancel() {
      $uibModalInstance.dismiss({});
    }

    function canSubmit() {
      return !vm.submitted && vm.errors.length === 0;
    }

    function changeSetCategory(category) {
      vm.showSetIcons = false;
      vm.selectedCategory = category;
    }

    function disableFinish() {
      if (vm.isPlacesImport)
        return vm.submitted  || vm.errors.length > 0 || !vm.setName;

      return vm.submitted  || vm.errors.length > 0;
    }

    function getSetLabel() {
      if (showSetName()) {
        return $translate.instant("templates.locations.newSetName");
      } else if (showSetList()) {
        return $translate.instant("common.import.selectSet");
      } else {
        return "";
      }
    }

    function getDisplayErrors() {
      //Only show 100 of these errors max to prevent UI issues
      return alkImportService.filterErrors(vm.errors);
    }

    function setNameExists() {
      if (!vm.setName || vm.importType !== 0) {
        return false;
      }
      return _.some(vm.sets, function (set) {
        if (!set.Name || !vm.setName) {
          return false;
        }
        return set.Name.toLowerCase() === vm.setName.toLowerCase();
      });
    }

    function showSetName() {
      return (vm.isPlacesImport || vm.isExceptionsImport) && vm.importType === 0;
    }

    function showSetList() {
      return (vm.isPlacesImport || vm.isExceptionsImport) && vm.importType >= 1;
    }

    function validate() {
      _.remove(vm.errors, function(error) { return error === vm.setExistsMessage; });
      if (setNameExists()) {
        vm.errors.push(vm.setExistsMessage);
      }
    }

    //Route Modifier specific function overrides
    function validateExceptions() {
      vm.errors = [];
      if (vm.setNameExists()) {
        vm.errors.push(vm.setExistsMessage);
      }

      //Preventing naming of closure set types for creating new sets
      if (vm.importType === 0) {
        if (vm.setName === "Closures" || vm.setName === "Closure_Default_rc") {
          vm.errors.push($translate.instant("templates.exceptions.invalidClosureName"));
        }
      }
    }

    function submitExceptions() {
      if (!vm.canSubmit()) 
      {
        return;
      }
      vm.submitted = true;

      vm.validate();
      if (vm.errors.length > 0) {
        vm.submitted = false;
        return;
      }

      let setId = "";
      let setName = "";
      let replace = "";
      if (vm.importType === 0) {
        setName = vm.setName;
      } else if (vm.importType === 1) {
        setId = vm.selectedSet.SetID;
      } else if (vm.importType === 2) {
        setId = vm.selectedSet.SetID;
        replace = true;
      }
      alkImportService.importExceptions(vm.file, setId, setName, replace).then(response => {
        alkModalService.clearWizardData();
        $uibModalInstance.close({
          SetID: response.SetID
        });
      }, error => {
        vm.submitted = false;
        vm.errors.push($translate.instant("templates.importModifiers.importError"));
      });
    }

    function submit() {
      if (vm.submitted) return;
      vm.submitted = true;
      currentWizardData.setName = vm.setName;
      currentWizardData.selectedSet = vm.selectedSet;
      currentWizardData.importType = vm.importType;
      currentWizardData.copilotOptions = vm.copilotOptions;
      currentWizardData.selectedCategory = vm.selectedCategory;

      if (vm.isPlacesImport && vm.sets.length > 0) {
        vm.inputRowsToCreate.selectedSet = vm.selectedSet.name;
        vm.inputRowsToCreate.setName = vm.setName;
      }
      vm.inputRowsToCreate.importType = vm.importType;
      vm.inputRowsToCreate.copilotOptions = vm.copilotOptions;
      vm.inputRowsToCreate.categoryIcon = vm.selectedCategory;
      vm.importFunction(vm.inputRowsToCreate, vm.importType).then(function (response) {
        alkModalService.clearWizardData();
        $uibModalInstance.close(response);
      }, function (error) {
        vm.errors.push(error);
        vm.submitted = false;
      });

    }


    function updateSetNameFromFileName() {
      if (!vm.showSetName()) {
        return;
      }
      //Set a default set name (to the file name, without extension) if none is provided
      if (vm.errors.length === 0 && vm.setName === "" && vm.file) {
        var fileName = vm.file.name;
        var lastIndexOfDot = vm.file.name.lastIndexOf(".");
        if (lastIndexOfDot > 0)
          fileName = vm.file.name.substring(0, lastIndexOfDot);
        vm.setName = fileName;
        var fileNum = 1;
        while (vm.setNameExists()) {
          vm.setName = fileName + " (" + fileNum + ")";
          fileNum++;
        }
      }
    }

  }
})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-import/importDetailsModal.controller.js